export const TRATAMIENTO_DEBITO_AUTOMATICO_TYPE = {
    SIN_DEBITO_AUTOMATICO: 800,
    DEBITO_AUTOMATICO_OPCIONAL: 801,
    SOLO_DEBITO_AUTOMATICO: 802
}
